import { render, staticRenderFns } from "./OrderRefundTransactions.vue?vue&type=template&id=6188be22"
import script from "./OrderRefundTransactions.vue?vue&type=script&lang=js"
export * from "./OrderRefundTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports